import type { CardHooks } from "./registry";

/**
 * Saw it Coming — Utility / Reaction.
 *
 * Trigger: opponent plays a Utility - Maneuver, Utility - Reaction, OR
 * activates a Counter in a reaction window. (The action chain entry is
 * pushed by playUtility / activateCounter in playtestEngine.ts.)
 *
 * Effect: negate the most recent action chain entry made by the opponent.
 * "Negate" means the opponent fully recovers any stamina that was spent,
 * and the maneuver/reaction/counter's effect is cancelled. The card
 * itself stays where it currently is — discarded cards stay discarded;
 * counters stay in hand if previously kept. Only the EFFECT is reversed
 * and the stamina is refunded.
 *
 * Implementation: this hook is a no-op marker. The actual negation is
 * performed by `negateLastOpponentChainEntry` in playtestEngine.ts, which
 * is invoked by playUtility right after the hook returns when the played
 * card is "Saw it Coming". This keeps the negation logic alongside the
 * other engine state mutations (stamina refund, zone cleanup, prompt
 * clearing) where it belongs, while still registering the card so it
 * appears in the registry and triggers correctly.
 */
export const sawItComing: CardHooks = {
  onUtilityPlay: (_ctx) => {
    // No prompt, no immediate effect. The engine recognizes this card by
    // name after the hook fires and performs the negation.
    return {
      log: ["Saw it Coming — negating most recent opposing action."],
    };
  },
};
